import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Component } from '@angular/core';
import { LoadingService } from '../../services/loading.service';
import { NgIf, AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-progress-spinner',
  standalone: true,
  imports: [NgIf, AsyncPipe],
  templateUrl: './progress-spinner.component.html',
  styleUrl: './progress-spinner.component.scss',
})
export class ProgressSpinnerComponent {
  pagePortal: ComponentPortal<any>;
  overlayRef: OverlayRef;
  loadingState = false;

  constructor(public loadingService: LoadingService) {}
}
